// @ts-strict-ignore
import {
  AfterViewChecked,
  Directive, DoCheck,
  HostBinding,
  Input, OnInit
} from '@angular/core';
import { AppConstants } from '@utils/app.constants';
import { LMStyleDirectiveBase } from './lm-style-directive.base';

@Directive({
  selector: '[lm-field-style]'  // tslint:disable-line
})
export class LMFieldStyleDirective extends LMStyleDirectiveBase implements OnInit {

  @HostBinding('class.alignRight') isAlignRight = false;

  // force certain types to be left-aligned
  @HostBinding('class.alignLeftForce') isAlignLeftForce = false;

  @Input() displayAsText: boolean;
  @Input() specField: LMSpecField;
  @Input() set fieldStyle(fieldStyle: LMFieldStyle) {
    this.style = fieldStyle;
  }

  ngOnInit() {
    this.setStyles();
    this.setAlignment();
  }

  private setAlignment(): void {
    if (!this.specField) {
      this.isAlignRight = false
      this.isAlignLeftForce = false;
    } else {
      const makeRight = this.alignRight();
      this.isAlignRight = makeRight;
      this.isAlignLeftForce = !makeRight;
    }
  }

  private alignRight(): boolean {
    // 1 - check if state field
    if (this.specField.hasUserDefinedStates
      || this.specField.stateValues
      || this.specField.selectable) {
      return false;
    }

    // 2 - check if numeric key field
    if ((this.specField.isContextKey
      || this.specField.isKeyField
      || this.specField.isSymbolicKey
      || this.specField.isPartOfRelativeKey)
      && this.specField.type === AppConstants.NUMERIC) {
      return false;
    }

    // 3 & 4 = check if alpharight or if a number type
    if ((this.specField.type === AppConstants.ALPHARIGHT && !this.displayAsText)
      || this.specField.type === AppConstants.BCD
      || this.specField.type === AppConstants.PERCENT
      || this.specField.type === AppConstants.NUMERIC) {
      return true;
    }

    return false;
  }
}
